<template>
  <div class="row steps">
    <div class="col step1" :class="{current: status === 1, complete: status > 1}">
      <span class="fas fa-user step-icon" v-show="status <= 1"></span>
      <span class="fas fa-check step-icon" v-show="status > 1"></span>
      <strong>{{status <= 1 ? 'Step 1:' : 'Done'}}</strong>
      <p>Set up your account</p>
    </div>
    <div class="col step2" :class="{current: status === 2, complete: status > 2}">
      <span class="fas fa-briefcase step-icon" v-show="status <= 2"></span>
      <span class="fas fa-check step-icon" v-show="status > 2"></span>
      <strong>{{status <= 2 ? 'Step 2:' : 'Done'}}</strong>
      <p>Tell us about your business</p>
    </div>
    <div class="col step3" :class="{current: status === 3, complete: status > 3}">
      <span class="fas fa-cog step-icon" v-show="status <= 3"></span>
      <span class="fas fa-check step-icon" v-show="status > 3"></span>
      <strong>{{status <= 3 ? 'Step 3:' : 'Done'}}</strong>
      <p>Get your aio* cards</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      status: Number
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .steps {
    border: 1px solid #ddd;
    margin-bottom: 33px;

    div {
      padding: 10px 14px;
      color: #ccc;
      background-color: #fafafa;
      border-left: 1px solid #ddd;

      p {
        margin: 14px 0 0 0;
      }

      .step-icon {
        float: left;
        font-size: 23px;
        margin-right: 15px;
      }

      &.current {
        color: #333;
        background-color: #fff;

        .step-icon {
          color: $cyan;
        }
      }

      &.complete {
        color: #767676;

        .step-icon {
          color: #6cc644;
        }
      }

      &:first-child {
        border-left: 0;
      }
    }
  }
</style>
